import type { TAccessLevel, TModule, TStatus } from '../common';

export interface ISearch {
  page: number;
  size?: number;
  fuz_template_name?: string;
  group_code?: string;
  // group_type=1 能力中心所有模板，  group_type=0 模板中心所有模板
  group_type?: number;
  combination_support?: boolean;
  module_list?: string;
}

export interface ITemplateGroup {
  group_name: string;
  group_code: string;
  priority: number;
  /** 0:场景中心分组 1: 能力中心分组 */
  group_type: number;
  icon: string;
}

export interface ITemplate {
  template_name: string;
  template_code: string;
  template_category: string;
  priority: number;
  template_desc: string;
  module: TModule;
  /** 是否为支持单文本多能力 */
  combination_support: boolean;
  cover_image: string;
  item_count: number | null;
  create_time: string;
  /** 是否为自定义模板 */
  is_builtin: boolean;
  is_favorite: boolean;
  update_time: string;
  open_flow: boolean; // 是否开启流程
  creator: string;
  /** 模板分组所属组织。 可以为NULL，表示内置分组。 */
  org_uid: string | null;
  flow_need_head: boolean; // 是否需要负责人
  file_extension_constraints: string[];
}

export interface ITaskInBatch {
  task_name: string;
  task_code: string;
  status: TStatus;
  module: TModule;
  template_name: string;
  template_code: string;
  key_result: string | null;
  current_node_name?: string;
  batch_id: number;
}

export interface IDiffInfo {
  detail_code: string;
  file_name: string;
  status: TStatus;
  key_result: string | null;
}

export interface ITask {
  task_name: string;
  task_code: string;
  status: TStatus;
  template_name: string;
  template_code: string;
  create_time: string;
  update_time: string;
  access_level: TAccessLevel;
  combination_support: boolean;
  batch_id: number;
  current_node_name?: string;
  key_result: string | null;
  module: TModule;
  // 0/1/2 个人/部门/组织
  tasks_in_batch: ITaskInBatch[] | null;
  collaborators: ICollaborator[] | null;
  creator_name: string;
  creator_avatar: string;
  is_creator: boolean;
  diff_info: IDiffInfo[];
}

export interface ITag {
  tag_code: string;
  tag_name: string;
}

export interface ITemplateConfig1 {
  // dependencies: Record<string, { template_name: string; tags: ITag[] }>;
  tags: Array<ITag & { source_templates: string[] }>;
}

export interface ITemplateConfig2 {
  combined_templates: {
    template_code: string;
    template_name: string;
    module: string;
  }[];
}

export interface ITemplateConfig3 {
  tags: [{ tag_code: string; tag_name: string }];
}

export interface ITemplateConfig {
  template_config: ITemplateConfig1 | ITemplateConfig2;
}

export type ITemplateDetail = ITemplate &
  ITemplateConfig & {
    preview_pdf_url: string;
    preview_task_code: string;
  };

export interface ITemplateWithPage extends ITemplate {
  page: number;
}

export interface IQueryTask {
  page: number;
  size: number;
  template_code?: string;
  need_handle?: boolean;
  keyword?: string;
  created_by?: 'SELF' | 'OTHERS' | '';
  update_time_order?: 'desc' | 'asc';
}

export interface ICollaborator {
  uid: string;
  name: string;
  avatar: string;
  /** 0: 个人 1: 部门 2: 组织 */
  entity_type: 0 | 1 | 2;
}

export interface FetchRecommendTemplateRes {
  /*** 是否单文件模板，单文件模板可以在单文件多模板场景下使用 */
  combination_support: boolean;
  /*** 封面图url*/
  cover_image: string;
  /*** 模板创建时间，yyyy-MM-dd HH:mm:ss 格式 */
  create_time: string;
  /*** 内置标记，是否内置模板*/
  is_builtin: string;
  /*** 收藏标记，判断是否被当前用户收藏*/
  is_favorite: boolean;
  /*** 底层模型图片支持标记*/
  is_image_based: boolean;
  /*** 底层模型PDF支持标记*/
  is_pdf_based: boolean;
  /*** 条目数，模板预设的 抽取点/审核点 等数量*/
  item_count: number | null;
  /** * 底层模块 */
  module: Module;
  /*** 所属组织UID，若NULL， 则该模板为系统内置模板，作用域为系统全局。 */
  org_uid: null | string;
  /*** 排序优先级，值越小，优先级越高*/
  priority: number;
  /*** 模板编号*/
  template_code: string;
  /*** 模板介绍*/
  template_desc: null | string;
  /*** 模板名称 */
  template_name: string;
}

/**
 * 底层模块
 */
enum Module {
  API = 'API',
  Aggregation = 'AGGREGATION',
  Correct = 'CORRECT',
  Diff = 'DIFF',
  FinancialAnalysis = 'FINANCIAL_ANALYSIS',
  Keyword = 'KEYWORD',
  Ocr = 'OCR',
  Review = 'REVIEW',
  Scene = 'SCENE',
  Structure = 'STRUCTURE',
  Table = 'TABLE',
  Tagging = 'TAGGING',
}
